module.exports = __webpack_public_path__ + "img/starts.bc811780.gif";